import { render, staticRenderFns } from "./RoApcnPopupTableInfo5.vue?vue&type=template&id=e484aab4&"
import script from "./RoApcnPopupTableInfo5.vue?vue&type=script&lang=js&"
export * from "./RoApcnPopupTableInfo5.vue?vue&type=script&lang=js&"
import style0 from "./RoApcnPopupTableInfo5.vue?vue&type=style&index=0&id=e484aab4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports